import {
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { updateThemeConfig } from "../../actions";
import { formatName } from "./ThemeConfig";
import { Box, Grid, Typography } from "@mui/material";
function SelectComponent({ ...props }) {
  const dispatch = useDispatch();
  return (
    <Box sx={{padding:'15px 0 !important'}}>
      <Grid container spacing={2}>
        <Grid item xs={12}><Typography>{formatName(props.field.name)}</Typography></Grid>
        <Grid item xs={12}>
          <RadioGroup
            style={{justifyContent:"center"}}
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={props.field.value}
            onChange={(e) => {
              dispatch(updateThemeConfig(props.field.name, e.target.value));
            }}
          >
            <FormControlLabel value="number" control={<Radio />} label="Number" labelPlacement="bottom"/>
            <FormControlLabel value="text" control={<Radio />} label="Text" labelPlacement="bottom"/>
          </RadioGroup>
        </Grid>
      </Grid>
    </Box>
  );
}

export default SelectComponent;
